import React from "react";
import RequestorTable from "./RequestorTable";

function RequestorMain() {
  return (
    <>
      {" "}
      <div className="devops-background-inner">
        <RequestorTable />
      </div>
    </>
  );
}

export default RequestorMain;
